export default class ExamListForm {
  asCompany = 1;
  isInterview = 1;
  companyId = 0;
  userId?: 0;
  examId = 0;
  afterEnd?: number;
  isPlaying?: number;
  beforeStart?: number;
  nameOrRemark = "";
  nameOrRemarkOrExamId = "";
  name = "";
  page = 1;
  pageSize = 10;
  platform = "pc";
  remark = "";
  examType = ""; // normal:旧版 aibuilder:通用版/重构版 aiworker:普工版
  examTypeList: any = []; // normal:旧版 aibuilder:通用版/重构版 aiworker:普工版
  createdTime: string[] = []; // 创建时间
  lastUpdateTime: string[] = []; // 最后更新时间
}

export class ExamGetForm {
  examId = 0;
  companyId = 0;
}

export class ExamGetAllForm {
  // userId = 0;
  companyId = 0;
  examType = "";
}

export class UploadParamsForm {
  ucCompanyId = 0;
  examId = 0;
}

export class ExamCopyForm {
  companyId = 0;
  examId = 0;
  name = "";
  departmentNo = "";
}

export class ExamDeleteForm {
  companyId = 0;
  examId = 0;
}
